<template>
<div id="edit-newsletter-type">
  <h2>
    Edit Newsletter Type '<router-link
      :to="{
        name: 'newsletter_type',
        params: {
          'newsletterTypeId': newsletterTypeId
        }
      }"
    >{{ name }}</router-link>'
  </h2>

  <newsletter-type-nav
    :newsletterTypeId="newsletterTypeId"
  ></newsletter-type-nav>

  <newsletter-type-form
    :newsletterTypeId="newsletterTypeId"
  ></newsletter-type-form>
</div>
</template>

<script>
import NewsletterTypeForm from '@/components/NewsletterTypeForm'
import NewsletterTypeNav from '@/components/NewsletterTypeNav'

import NewsletterTypeStore from '@/stores/NewsletterTypeStore'

export default {
  data () {
    return NewsletterTypeStore.state
  },

  components: {
    'newsletter-type-nav': NewsletterTypeNav,
    'newsletter-type-form': NewsletterTypeForm
  },

  props: ['newsletterTypeId'],

  created () {
    this.get()
  },

  methods: {
    get () {
      this.apiGet('/newsletter_types/' + this.newsletterTypeId, NewsletterTypeStore, true)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeEdit.vue